<template>
  <!-- Główny kontener widoku Białej Listy -->
  <div class="content-container">
    <!-- Panel filtrów archiwalnych po lewej stronie -->
    <filters-archival-measurements />
    <div class="content-wrap">
      <!-- Pasek górnego menu (nawigacja) -->
      <TopMenu />
      <!-- Komponent wyświetlający białą listę pojazdów -->
      <WhiteList />
    </div>
  </div>
</template>

<script>
// Importujemy wymagane komponenty widoku
import TopMenu from "../components/TopMenu.vue";
import FiltersArchivalMeasurements from "../components/FiltersArchivalMeasurements.vue";
import WhiteList from "../components/WhiteList.vue";

export default {
  name: "WhiteListView", // Nazwa widoku (pomocna np. przy debugowaniu)
  components: {
    TopMenu,                    // Pasek menu u góry
    WhiteList,                  // Główna tabela białej listy pojazdów/kontaktów
    FiltersArchivalMeasurements // Panel boczny z filtrami archiwalnymi
  },
};
</script>

<style scoped>
/* Spójne tło z BlackListView/ContactView. */
.content-container {
  background-color: #eef0ec;
}
</style>
